import {
  ProcessCellForExportParams,
  ProcessHeaderForExportParams,
} from '@ag-grid-community/core';
import { black } from 'src/theme/colors';

export const processContractTableHeaderCallback = (
  params: ProcessHeaderForExportParams,
) => {
  if (params.column.getColId() === 'recipient') {
    // For the 'recipient' column, we need to display three separate columns in the CSV export.
    // This is because the 'recipient' column contains nested information (first name, last name, email)
    // that we want to present as individual columns in the exported CSV.
    return `"Recipient first name","Recipient last name","Recipient email"`;
  }

  return `"${params.column.getColDef().headerName || ''}"`;
};

export const processContractTableCellCallback = (
  params: ProcessCellForExportParams,
) => {
  const rowData = params.node?.data;
  const colId = params.column.getColId();

  // Customize cell values during CSV export based on column ID.
  switch (colId) {
    case 'recipient':
      return `"${rowData.recipient?.givenName || ''}","${
        rowData.recipient?.familyName || ''
      }","${rowData.recipient?.email || ''}"`;

    case 'createdAt':
    case 'submissionDate':
    case 'latestSubmissionDate':
      return rowData[colId]
        ? `${new Date(Date.parse(rowData[colId])).toLocaleDateString()}`
        : '';

    // status column first letter to uppercase
    case 'status': {
      const status = rowData[colId] || '';
      return status[0].toUpperCase() + status.slice(1);
    }
    // requestsCount and submissionsCount columns should be 0 if null or undefined in the rowData object
    case 'requestsCount': {
      const requestsCount = rowData[colId];
      return requestsCount;
    }
    case 'submissionsCount': {
      const submissionsCount = rowData[colId];
      return submissionsCount;
    }
    default:
      return `"${params.value || ''}"`;
  }
};

/**
 * Converts a text string into a Base64-encoded image.
 * @returns {string} - A Promise that resolves with the Base64-encoded image.
 */
export function textToBase64Image({
  height,
  width,
  value,
}: {
  height: number;
  width: number;
  value: string;
}) {
  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');

  if (!context) return '';

  canvas.width = width;
  canvas.height = height; // Set height as needed

  context.fillStyle = black;

  context.fillText(value || '', 0, 0);

  // Convert the canvas content to a data URL
  const dataURL = canvas.toDataURL('image/png');

  // Return the Base64-encoded image
  return dataURL;
}
